import React from 'react'

function AdminContactus() {
  return (
    <div>AdminContactus</div>
  )
}

export default AdminContactus